export const SET_APP_CAPTCHA = 'SET_APP_CAPTCHA'
